import { JKOrder } from "./order";

export const appApis = {
    JKOrder: JKOrder,
};
